<template>
    <div class="layout-vant-discuss-recall-popup">
        <van-popup :value="showPop" position="bottom" @click-overlay="clickOverlay">
            <div class="layout-vdrp-title">是否撤回该条消息？</div>
            <div class="layout-vdrp-confirm" @click="clickConfirm">确定</div>
            <div class="layout-vdrp-cancel" @click="clickCancel">取消</div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'VantDiscussRecallPop',
    props: {
        showPop: {
            type: Boolean,
            default() { return false }
        },
        overlayFunc: {
            type: Function,
            default() { return function() {} }
        },
        confirmFunc: {
            type: Function,
            default() { return function() {} }
        },
        cancelFunc: {
            type: Function,
            default() { return function() {} }
        }
    },
    methods: {
        clickOverlay() {
            if(typeof(this.overlayFunc) == 'function') {
                this.overlayFunc();
            }
        },
        clickConfirm() {
            if(typeof(this.confirmFunc) == 'function') {
                this.confirmFunc();
            }
        },
        clickCancel() {
            if(typeof(this.cancelFunc) == 'function') {
                this.cancelFunc();
            }
        }
    }
}
</script>